import React, { useState } from "react";
import { Box, Button, Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { createCommissionDispatch } from "../../store/reducers/userProfileReducer";
import CommissionSlider from "./CommissionSlider";
import RepeatDiscountSlider from "./RepeatDiscountSlider";
import Title from "../../components/ReusableComponents/title";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import copyIcon from '../../assets/icons/copy-white.svg';

function CreateAffiliate() {
  const dispatch = useDispatch();
  const { url, referalCode, aff_percentage_range } = useSelector(
    (state) => state.user
  );

  const [comValue, setComValue] = useState(6);
  const [repeatDiscountValue, setRepeatDiscountValue] = useState(9);
  const [showPopup, setShowPopup] = useState(false);
  const [popupHead, setPopupHead] = useState("");
  const [popupBody, setPopupBody] = useState("");
  const [popupType, setPopupType] = useState('');
  const [link, setLink] = useState(false);
  const noteText = "NOTE: Fixed Commission Income rates for company is 15%."; // Note text to be copied

  const handleCopyNote = () => {
    navigator.clipboard
      .writeText(noteText)
      .then(() => {
        setPopupHead("Copied!");
        setPopupBody("The note has been copied to your clipboard.");
        setShowPopup(true);
      })
      .catch((err) => {
        setPopupHead("Error!");
        setPopupBody("Failed to copy the note. Please try again.");
        setShowPopup(true);
      });
  };

  const handleSubmit = () => {
    const payload = {
      percentage: comValue,
      repeat_percent: repeatDiscountValue,
    };

    dispatch(createCommissionDispatch(payload))
      .then((res) => {
        setLink(true);
        if (res.status && res.status !== 200) {
          setPopupHead("Error");
          setPopupBody(res.data.message || "Something went wrong. Try Again!");
          setPopupType("error");
          setShowPopup(true);
        } else {
          setPopupHead("Woo Hoo");
          setPopupBody("Affiliate Link successfully created");
          setPopupType("success");
          setShowPopup(true);
        }
      })
      .catch((err) => {
        setPopupHead("Error");
        setPopupBody(err.response?.data?.detail || "Something went wrong. Try Again!.");
        setPopupType("error");
        setShowPopup(true);
      });
  };

  const handleComValueChange = (value) => {
    const newComValue = value;
    const newRepeatValue = 15 - newComValue;

    setComValue(newComValue);
    setRepeatDiscountValue(newRepeatValue);
  };

  const handleRepeatDiscountValueChange = (value) => {
    const newRepeatValue = value;
    const newComValue = 15 - newRepeatValue;

    setRepeatDiscountValue(newRepeatValue);
    setComValue(newComValue);
  };

  return (
    <div>
      <Box>
        <Grid item xs={12}>
          <Grid className="affiliate-link" mt={3} style={{ textAlign: "left" }}>
            <Title Styles={{ marginBottom: "10px" }}>
              Create Affiliate Code
            </Title>

            <div className="create_affiliate_code">
              <div className="info_box" style={{ justifyContent: "space-between" }}>
                <div>
                  <span>
                    NOTE: <br /> Only user who sign up with the below link can use the Unique Coupon Code as a Discount Coupon
                  </span>
                </div>
                <button className="copy_btn" onClick={handleCopyNote}>
                  <img src={copyIcon} alt="" /> Copy
                </button>
              </div>

              <div className="commission">
                <CommissionSlider
                  min={0}
                  max={aff_percentage_range}
                  value={comValue}
                  onChange={handleComValueChange}
                />
                <RepeatDiscountSlider
                  min={0}
                  max={15}
                  value={repeatDiscountValue}
                  onChange={handleRepeatDiscountValueChange}
                />

                {referalCode && link && (
                  <div className="input_wrapper">
                    <span className="title">Your Affiliate Link</span>
                    <input className="input" type="text" value={url} readOnly />
                  </div>
                )}
              </div>

              <div className="btn_wrapper">
                <Button
                  className="unique-code-generate-button"
                  variant="contained"
                  onClick={handleSubmit}
                  style={{
                    padding: "10px 50px",
                    borderRadius: "15px",
                    textTransform: "capitalize",
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>

      {showPopup && (
        <CombinedPopup
          head={popupHead}
          subhead={popupBody}
          type={popupType} 
          trigger={showPopup}
          setTrigger={setShowPopup} 
        />
      )}
    </div>
  );
}

export default CreateAffiliate;
